import { providerPasscodeLoginApi } from '@ax/service';
import { ProviderPasscodeLoginInput } from '@ax/service/src/auth-interface';
import { useMutation } from '@tanstack/react-query';

export function useProviderPasscodeLogin() {
  return useMutation({
    mutationKey: ['provider-passcode-login'],
    mutationFn: (input: ProviderPasscodeLoginInput) => providerPasscodeLoginApi(input),
    onError: (error: any) => {
      console.log(error);
    },
  });
}
